import React, {useState, getGlobal} from 'reactn';
import { Form, Input , Button} from 'antd';
import { useFirestore, useStorage } from 'reactfire';
// import { storage } from 'firebase';
const { TextArea } = Input;

const SingleTest = (props) => {

    const [state, setState] = useState({testname: props.testname});
    const [imageURL, setImageURL] = useState(null);
    const [imgLoading, setImageLoading] = useState(false);
    const firestore = useFirestore();
    const [loadingBtn, setLoadingBtn] = useState(false);
    const storage = useStorage();
    const getValue = e => {
        setState({...state, note: e.target.value});
    }

    const addTest = () => {
        setLoadingBtn(true);
        firestore.collection('Investigation_records').add({
            patient: firestore.collection("patients").doc(getGlobal().patientID),
            appointment: firestore.collection("appointments").doc(getGlobal().appointmentId),
            appointment_id: getGlobal().appointmentId,
            test_info: state,
            test_image_url: imageURL,
            timestamp: new Date(),
          }).then(() => {
            console.log('Successfully Added');
            props.recAdded();
            setLoadingBtn(false);
        });
    }

    const uploadFile = (event) => {
        setImageLoading(true);
        const currImage = event.target.files[0];
        const uploadTask = storage.ref(`investigation/${currImage.name}`).put(currImage);
        uploadTask.on("state_changed", snapshot => {}, error => {console.log(error)}, () => {
            storage.ref("investigation").child(currImage.name).getDownloadURL().then( url => {
                setImageURL(url);
                setImageLoading(false);
            });
        });
    }

    return (
        <li>
            <div style={{display: 'flex', justifyContent: 'space-between'}}>
                <h4>{state.testname}</h4>
                {!imageURL && !imgLoading && <label className="uploadFile"> Upload Image
                    <input onChange={uploadFile} type="file" size="60" />
                </label> }
                {!imageURL && imgLoading && <span>Uploading</span>}

                {imageURL && <span>Image Uploaded</span>}
            </div>
            <Form.Item
            style={{marginBottom: '10px'}}
            name="note"
            >
                <TextArea onChange={getValue} placeholder="Enter Note" rows={1} />
            </Form.Item>
            <Button type="primary" htmlType="submit" loading={loadingBtn} onClick={addTest}>
                Add
            </Button>
        </li>
    );
}

export default SingleTest;
